import { post, get } from '../../../components/hooks/apiFetch';

export const useDiarizeApi = () => {
    const submitDiarizeRequest = async (filesWithFormats, speakerCount, comment = '', nextUtility = null, startTime = '') => {
        comment ??= '';
        const formData = new FormData();
        filesWithFormats.forEach((item, index) => {
            formData.append(`Files[${index}].File`, item.file, item.file.name);
            formData.append(`Files[${index}].OutputFormat`, item.outputFormat);
            if (item.templateName && item.templateName.trim() !== '') {
                formData.append(`Files[${index}].TemplateName`, item.templateName);
            }
        });

        formData.append("Options.MaxCountOfSpeakers", speakerCount);
        formData.append("Options.Comment", comment.trim());
        formData.append("Options.StartTime", startTime);

        if (nextUtility) {
            formData.append("Options.NextUtilityName", nextUtility);
        }

        const result = await post(`/api/diarize`, formData);

        return {
            id: result.id,
            identifier: result.identifier
        };
    };

    const cancelDiarizeTask = async (inputIdentifier) => {
        await get(`/api/diarize/cancel/${encodeURIComponent(inputIdentifier)}`);
        return true;
    };

    return { submitDiarizeRequest, cancelDiarizeTask };
};